var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,{"attrs":attrs,"on":on})]}}],null,true)},'v-tooltip',{..._vm.tooltipPositionProps, ..._vm.contentClassProp, ..._vm.$attrs},false),[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }